import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'planone-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  @Input() closable = true;

  @ContentChild('headline') headline!: TemplateRef<never> | null;
  @ContentChild('description') description!: TemplateRef<never> | null;
  @ContentChild('content') content!: TemplateRef<never> | null;
}
